<div class="container px-0" [hidden]="!(loading$ | async)">
  <div class="row gy-3">
    @for (item of [1, 2, 6, 7, 8, 9]; track item; let first = $first) {
      <div class="{{ [1, 2].includes(item) ? 'col-12' : 'col-12 col-lg-6' }} ">
        <spe-skeleton-card [noTitle]="!first" [noBody]="first" />
      </div>
    }
  </div>
</div>
<div
  class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-8"
  [hidden]="loading$ | async"
>
  <spe-titulo-sessao titulo="Despesas" [icone]="'assets/icones/cinza/pat.svg'"> </spe-titulo-sessao>
  <!-- select -->
  <div class="text-end mt-48 remove-mt-48-lgscreen mb-24">
    <form class="d-flex flex-column-reverse flex-lg-row align-items-center gap-2" [formGroup]="filterFormGroup">
      <mat-chip-set class="rounded-mat-chip" aria-label="Filtros ativos" *ngIf="!!drillDownFilterTitle">
        <mat-chip [removable]="true" (removed)="setDrillDownFilter('', '')">
          {{ drillDownFilterTitle }}
          <mat-icon class="color-brand-principal" matChipRemove>close</mat-icon>
        </mat-chip>
      </mat-chip-set>
      <mat-form-field
        class="mb-0"
        [ngClass]="commonService.switchMatErrorClassResponsivity(filterFormGroup.controls.startDate)"
      >
        <mat-label>Período</mat-label>

        <mat-date-range-input [dateFilter]="rangeFilter" [formGroup]="filterFormGroup" [rangePicker]="pickerRange">
          <input
            [errorStateMatcher]="dateRangeErrorStateMatcher"
            matStartDate
            formControlName="startDate"
            placeholder="Data inicial"
            readonly
          />
          <input
            [errorStateMatcher]="dateRangeErrorStateMatcher"
            matEndDate
            formControlName="endDate"
            placeholder="Data final"
            readonly
          />
        </mat-date-range-input>

        <mat-datepicker-toggle type="button" matIconSuffix [for]="pickerRange"
          ><mat-icon matDatepickerToggleIcon svgIcon="calendario-current" class="color-brand-principal"></mat-icon
        ></mat-datepicker-toggle>
        <mat-date-range-picker #pickerRange></mat-date-range-picker>
        <mat-hint
          class="background-brand-principal color-branco rounded-16 mt-1 pb-1 px-2"
          [align]="'end'"
          *ngIf="
            pickerRange.opened &&
            (!filterFormGroup.controls.startDate.value ||
              (filterFormGroup.controls.startDate.value && filterFormGroup.controls.endDate.value))
          "
          >Selecione a data inicial</mat-hint
        >
        <mat-hint
          class="background-brand-principal color-branco rounded-16 mt-1 pb-1 px-2"
          [align]="'end'"
          *ngIf="
            pickerRange.opened && filterFormGroup.controls.startDate.value && !filterFormGroup.controls.endDate.value
          "
          >Selecione a data final</mat-hint
        >
        <mat-error *ngIf="filterFormGroup.controls.startDate.invalid">
          {{ validatorErrors(filterFormGroup.controls.startDate) }}
        </mat-error>
        <mat-error *ngIf="filterFormGroup.controls.endDate.invalid">
          {{ validatorErrors(filterFormGroup.controls.endDate) }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="d-block d-lg-inline-block mb-0">
        <mat-label>Status da prestação</mat-label>
        <mat-select name="statusPrestacao" formControlName="statusPrestacao">
          <mat-option *ngFor="let element of statusPrestacao" [value]="element.value">{{ element.label }}</mat-option>
        </mat-select>
        <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </form>
  </div>
</div>
<spe-dashboard-content
  [drillDownFilter]="drillDownFilter"
  [kpiTotalDespesasValor]="kpiTotalDespesasValor"
  [statusPrestacaoFilter]="statusPrestacaoFilter"
  [startDate]="startDate"
  [endDate]="endDate"
></spe-dashboard-content>
